export default "/naksan.glb";